import { Routes } from '@angular/router';
import { authGuardNative } from './core/guards/auth.guard';
import { userResolver } from './core/resolvers/user.resolver';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { languageGuard } from './core/guards/language.guard';
import { pinSetGuard } from './core/guards/pin-set.guard';
import { pinAuthGuard } from './core/guards/pin-auth.guard';
import { pinSetupAccessGuard } from './core/guards/pin-setup-access.guard';
import { PinSetupComponent } from './auth/pin-setup/pin-setup.component';
import { PinAuthComponent } from './auth/pin-auth/pin-auth.component';
import { pinAuthAccessGuard } from './core/guards/pin-auth-access.guard';

export const APP_ROUTES_NATIVE: Routes = [
  {
    path: 'pin-setup',
    title: 'RedRock Pool - PIN Setup',
    component: PinSetupComponent,
    canActivate: [languageGuard, authGuardNative, pinSetupAccessGuard],
  },
  {
    path: 'pin-auth',
    title: 'RedRock Pool - Sign In',
    component: PinAuthComponent,
    canActivate: [languageGuard, authGuardNative, pinAuthAccessGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [languageGuard, pinSetGuard, pinAuthGuard],
    children: [
      {
        path: '',
        title: 'RedRock Pool | Bitcoin Mining Pool with FPPS Payouts',
        loadChildren: () =>
          import('./pool/pool.routing').then((mod) => mod.POOL_ROUTES),
        data: {
          containerCustomClass: 'container-fluid',
        },
      },
      {
        path: 'profile',
        title: 'RedRock Pool - User Profile',
        canActivate: [authGuardNative],
        resolve: [userResolver],
        loadChildren: () =>
          import('./profile/profile.routes').then((mod) => mod.PROFILE_ROUTES),
      },
      {
        path: 'mining',
        title: 'RedRock Pool - Mining',
        canActivate: [authGuardNative],
        resolve: [userResolver],
        loadChildren: () =>
          import('./mining/mining.routing').then((mod) => mod.MINING_ROUTES),
      },
      {
        path: 'finance',
        title: 'RedRock Pool - Assets',
        canActivate: [authGuardNative],
        resolve: [userResolver],
        loadChildren: () =>
          import('./finance/finance.routing').then(
            (mod) => mod.FINANCE_ROUTING,
          ),
      },
      {
        path: 'reports',
        title: 'RedRock Pool - Reports',
        canActivate: [authGuardNative],
        resolve: [userResolver],
        loadChildren: () =>
          import('./reports/reports.routes').then((mod) => mod.REPORTS_ROUTES),
      },
      {
        path: 'observer',
        title: 'RedRock Pool - Observer',
        loadChildren: () =>
          import('./observer/observer.routing').then(
            (mod) => mod.OBSERVER_ROUTES,
          ),
      },
      {
        path: 'help',
        title: 'RedRock Pool - Help',
        loadChildren: () =>
          import('./help/help.routing').then((mod) => mod.HELP_ROUTES),
      },
      {
        path: '404',
        title: 'RedRock Pool - Page Not Found',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'login',
    title: 'RedRock Pool - Sign In',
    canActivate: [languageGuard],
    loadChildren: () =>
      import('./auth/auth.routing').then((mod) => mod.AUTH_ROUTES_NATIVE),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
